import { createSlice } from "@reduxjs/toolkit";
import {
    setAvailabilityStatus,
    getAvailabilityStatus,
    getAllUsersAvailability,
    getUpcomingMeetings
} from './thunk';

export const initialState = {
    currentUserAvailability: {
        availability_status: 'Available',
        status_message: null,
        auto_update_meetings: true
    },
    allUsersAvailability: [],
    upcomingMeetings: [],
    errors: {},
    loading: false
};

const AvailabilitySlice = createSlice({
    name: 'Availability',
    initialState,
    reducers: {
        clearAvailabilityState: (state: any) => {
            state.currentUserAvailability = initialState.currentUserAvailability;
            state.allUsersAvailability = [];
            state.upcomingMeetings = [];
            state.errors = {};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(setAvailabilityStatus.pending, (state: any) => {
            state.loading = true;
            state.errors = {};
        });
        builder.addCase(setAvailabilityStatus.fulfilled, (state: any, action: any) => {
            state.loading = false;
            if (action.payload) {
                state.currentUserAvailability = action.payload;
            }
            state.errors = {};
        });
        builder.addCase(setAvailabilityStatus.rejected, (state: any, action: any) => {
            state.loading = false;
            state.errors = { message: action.error?.message || 'Failed to set availability status' };
        });

        builder.addCase(getAvailabilityStatus.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getAvailabilityStatus.fulfilled, (state: any, action: any) => {
            state.loading = false;
            if (action.payload) {
                state.currentUserAvailability = action.payload;
            }
            state.errors = {};
        });
        builder.addCase(getAvailabilityStatus.rejected, (state: any, action: any) => {
            state.loading = false;
            state.errors = { message: action.error?.message || 'Failed to get availability status' };
        });

        builder.addCase(getAllUsersAvailability.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getAllUsersAvailability.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.allUsersAvailability = action.payload || [];
            state.errors = {};
        });
        builder.addCase(getAllUsersAvailability.rejected, (state: any, action: any) => {
            state.loading = false;
            state.errors = { message: action.error?.message || 'Failed to get all users availability' };
            state.allUsersAvailability = [];
        });

        builder.addCase(getUpcomingMeetings.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getUpcomingMeetings.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.upcomingMeetings = action.payload || [];
            state.errors = {};
        });
        builder.addCase(getUpcomingMeetings.rejected, (state: any, action: any) => {
            state.loading = false;
            state.errors = { message: action.error?.message || 'Failed to get upcoming meetings' };
            state.upcomingMeetings = [];
        });
    }
});

export const { clearAvailabilityState } = AvailabilitySlice.actions;
export default AvailabilitySlice.reducer;

